/* NEWRON — scripts propios (sin librerías). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.nw-reveal:not(.nw-visible), .nw-espectro:not(.nw-visible), [data-nw-contar]:not([data-nw-hecho])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nw-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('nw-visible');
        if (e.target.hasAttribute('data-nw-contar')) contar(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Cifras animadas: anima solo valores numéricos simples ("98.79"); el resto queda tal cual.
  function contar(el) {
    el.setAttribute('data-nw-hecho', '');
    var destino = el.getAttribute('data-nw-contar');
    if (!/^\d+(\.\d+)?$/.test(destino)) return;
    var final = parseFloat(destino);
    var decimales = (destino.split('.')[1] || '').length;
    var dur = 1600, t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (final * e).toFixed(decimales);
      if (p < 1) requestAnimationFrame(paso); else el.textContent = destino;
    }
    requestAnimationFrame(paso);
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-nw-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var k = parseFloat(img.getAttribute('data-nw-parallax')) || 0;
        img.style.transform = 'translate3d(0,' + (-r.top * k).toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initGaleria() {
    document.querySelectorAll('[data-nw-galeria]').forEach(function (g) {
      var principal = g.querySelector('[data-nw-principal]');
      if (!principal) return;
      g.querySelectorAll('[data-nw-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = 1;
          }, 180);
          g.querySelectorAll('[data-nw-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-nw-cantidad]').forEach(function (c) {
      var input = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-paso') === '+' ? 1 : -1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-nw-variantes]').forEach(function (form) {
      var datos = form.querySelector('script[type="application/json"]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var selects = form.querySelectorAll('[data-nw-opcion]');
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-nw-boton]');
      var precio = document.querySelector('[data-nw-precio="' + form.getAttribute('data-nw-variantes') + '"]');
      var moneda = form.getAttribute('data-nw-formato') || '${{amount}}';
      function formato(cents) {
        var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneda.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
      }
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-txt-no'); return; }
          idInput.value = v.id;
          btn.disabled = !v.available;
          btn.textContent = v.available ? btn.getAttribute('data-txt-si') : btn.getAttribute('data-txt-agotado');
          if (precio) precio.textContent = formato(v.price);
        });
      });
    });
  }

  function init() {
    initReveals();
    initParallax();
    initGaleria();
    initCantidad();
    initVariantes();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
